$(document).ready(function () {
    $('.wd-pro__rating-popup').on('click', function () {
        $('body').addClass('loox-open no-scroll');
        if (window.loox && typeof window.loox.init === "function") {
            try { window.loox.init(); } catch (e) { }
        }
    });
    $('.loox-overlay').on('click', function () {
        $('body').removeClass('loox-open no-scroll');
    });
    $('.loox-close-btn').on('click', function () {
        $('body').removeClass('loox-open no-scroll');
    });
    $(document).on('keyup', function (e) {
        if (e.key === "Escape") {
            $('body').removeClass('loox-open no-scroll');
        }
    });
});

$(document).ready(function() {
  const $sectionDiv = $('.internal-liking');
  const $targetDiv = $('.links-items');

  if ($sectionDiv.length && $targetDiv.length) {
    $targetDiv.append($sectionDiv);
  }
});

$(document).on('click', '.variant-option__swatch input[data-variant-id]', function() {
    var closestElement = $(this).closest('.product-item, .product-card, .product, .wd-product').find('.contents.user-select-text').first();
    
    if (closestElement.length > 0) {
        setTimeout(function() {
            closestElement[0].click();
        }, 1000);
    }
});